import { IAccessoriesCarouselCard } from '@models/IAccessoriesCarouselCard';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import slugify from '@utils/helpers/slugify';
import { SwiperSlide } from 'swiper/react';
import AccessoriesCarouselCard from './AccessoriesCarouselCard';

interface Props {
  readonly title?: string;
  readonly items?: IAccessoriesCarouselCard[];
  readonly anchorId?: string;
}

const AccessoriesCarousel = ({
  title = '',
  items = [],
  anchorId = '',
}: Props) =>
  items.length > 0 ? (
    <section
      id={`a-${anchorId}`}
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
    >
      <NavigationCarousel
        id={`accessories-carousel-${anchorId}`}
        shadows
        items={items}
        slidesToShowDesktop={6}
        slidesToShowTablet={3}
        title={title}
      >
        {(itemsToDisplay) =>
          itemsToDisplay
            .filter((item) => !!item.name)
            .map((item, index) => (
              <SwiperSlide
                key={slugify(`accessory-${item.name}-${index}`)}
                className="stretch-card"
              >
                <AccessoriesCarouselCard {...item} />
              </SwiperSlide>
            ))
        }
      </NavigationCarousel>
    </section>
  ) : null;

export default AccessoriesCarousel;
